(function () {
  var originalFilename = 'theme-v2-original-ada-cart-keyboard-20260619.js';

  function assetUrl(filename) {
    var script = document.currentScript;
    if (script && script.src) {
      try {
        return new URL(filename, script.src).toString();
      } catch (error) {}
    }
    return filename;
  }

  function loadOriginalTheme(callback) {
    var src = assetUrl(originalFilename);

    if (document.readyState === 'loading') {
      document.write('<script src="' + src.replace(/"/g, '&quot;') + '"><\\/script>');
      callback();
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = callback;
    script.onerror = callback;
    (document.head || document.documentElement).appendChild(script);
  }

  function installStyledSelectAriaFix() {
    if (window.__nestStyledSelectAriaFixV1) return;
    window.__nestStyledSelectAriaFixV1 = true;

    var selector = '.styledSelect[aria-hidden="true"][role="button"], .styledSelect[aria-hidden="true"][tabindex]';

    function fixStyledSelects(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var controls = [];

      if (scope.matches && scope.matches(selector)) controls.push(scope);
      if (scope.querySelectorAll) {
        controls = controls.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
      }

      controls.forEach(function (control) {
        control.removeAttribute('aria-hidden');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        fixStyledSelects(document);
      }, { once: true });
    } else {
      fixStyledSelects(document);
    }

    document.addEventListener('load', function () {
      fixStyledSelects(document);
    }, true);

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes') {
            fixStyledSelects(mutation.target);
            return;
          }

          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (node && node.nodeType === 1) fixStyledSelects(node);
          });
        });
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'class', 'role', 'tabindex', 'aria-haspopup']
      });
    }
  }

  function installExtendFocusGate() {
    if (window.__nestExtendFocusGate) return;
    window.__nestExtendFocusGate = true;

    var cartTriggerSelector = '[data-cart-toggle], [data-cart-drawer-open], [data-open-cart], [aria-controls="CartDrawer"], .site-header__cart, .header__icon--cart, a.site-header__cart[href="#"], a.header__icon--cart[href="#"]';
    var cartRootSelector = '.cart-modal, #CartDrawer, .cart-drawer, .drawer--cart, .ajax-cart, [data-cart-drawer], [data-cart-container]';
    var extendSelector = '#extend-offers-modal-iframe, #extend-learn-more-modal-iframe, iframe[src*="extend" i], iframe[id*="extend" i], [id*="extend" i][role="dialog"], [class*="extend" i][role="dialog"], [class*="extend" i][class*="modal" i]';
    var pendingCartOpenUntil = 0;
    var cartOpenQueued = false;

    function closest(element, selector) {
      return element && element.closest ? element.closest(selector) : null;
    }

    function isVisible(element) {
      if (!element || !document.documentElement.contains(element)) return false;
      if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
      var styles = window.getComputedStyle(element);
      if (styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0') return false;
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function findVisibleExtendModal() {
      var nodes = Array.prototype.slice.call(document.querySelectorAll(extendSelector));
      for (var i = 0; i < nodes.length; i++) {
        if (isVisible(nodes[i])) return nodes[i];
      }
      return null;
    }

    function findVisibleCart() {
      var nodes = Array.prototype.slice.call(document.querySelectorAll(cartRootSelector));
      for (var i = 0; i < nodes.length; i++) {
        if (isVisible(nodes[i])) return nodes[i];
      }
      return null;
    }

    function focusExtendModal(modal) {
      if (!modal) return false;
      if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');
      if (!modal.hasAttribute('title') && modal.tagName && modal.tagName.toLowerCase() === 'iframe') modal.setAttribute('title', 'Product protection options');
      if (!modal.hasAttribute('aria-label') && modal.tagName && modal.tagName.toLowerCase() !== 'iframe') modal.setAttribute('aria-label', 'Product protection options');
      try { modal.focus({ preventScroll: false }); } catch (error) { modal.focus(); }
      return true;
    }

    function closeVisibleCartWhileExtendIsOpen() {
      var modal = findVisibleExtendModal();
      if (!modal) return false;

      var cart = findVisibleCart();
      if (cart) {
        cart.style.display = 'none';
        cart.setAttribute('aria-hidden', 'true');
      }

      focusExtendModal(modal);
      return true;
    }

    function clickCartTriggerAfterExtend() {
      var trigger = document.querySelector(cartTriggerSelector);
      if (trigger && typeof trigger.click === 'function') trigger.click();
    }

    function waitForExtendCloseThenOpenCart() {
      if (!cartOpenQueued) return;
      var attempts = 0;

      function check() {
        attempts += 1;
        var modal = findVisibleExtendModal();
        if (modal && attempts < 240) {
          focusExtendModal(modal);
          window.setTimeout(check, 250);
          return;
        }

        cartOpenQueued = false;
        window.setTimeout(clickCartTriggerAfterExtend, 150);
      }

      check();
    }

    document.addEventListener('click', function (event) {
      var addControl = event.target && event.target.closest ? event.target.closest('.product-form__cart-submit, [data-add-to-cart], form[action*="/cart/add"] button, input[type="submit"]') : null;
      if (addControl) {
        pendingCartOpenUntil = Date.now() + 20000;
      }

      var cartTrigger = event.target && event.target.closest ? event.target.closest(cartTriggerSelector) : null;
      if (!cartTrigger) return;

      var extendModal = findVisibleExtendModal();
      if (!extendModal && Date.now() > pendingCartOpenUntil) return;

      if (extendModal) {
        event.preventDefault();
        event.stopImmediatePropagation();
        cartOpenQueued = true;
        focusExtendModal(extendModal);
        waitForExtendCloseThenOpenCart();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      var isActivationKey = event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';
      if (!isActivationKey) return;
      var addControl = event.target && event.target.closest ? event.target.closest('.product-form__cart-submit, [data-add-to-cart], form[action*="/cart/add"] button, input[type="submit"]') : null;
      if (addControl) pendingCartOpenUntil = Date.now() + 20000;
    }, true);

    if (window.MutationObserver) {
      new MutationObserver(function () {
        var modal = findVisibleExtendModal();
        if (!modal) return;
        cartOpenQueued = true;
        closeVisibleCartWhileExtendIsOpen();
        waitForExtendCloseThenOpenCart();
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'aria-hidden', 'hidden'] });
    }
  }

  function installCartRemoveKeyboardFix() {
    if (window.__nestCartRemoveKeyboardFixV3) return;
    window.__nestCartRemoveKeyboardFixV3 = true;

    var cartRootSelector = '.cart-modal, #CartDrawer, .cart-drawer, .drawer--cart, .ajax-cart, [data-cart-drawer], [data-cart-container], [data-cart-form], [class*="cart" i][role="dialog"]';
    var cartItemSelector = '[data-cart-item], .cart-item, .cart__row, .cart__item, .ajaxcart__product, .ajax-cart__item, [class*="cart-item" i], [class*="cart__item" i], li, tr';
    var removeSelector = [
      '[data-cart-remove]',
      '[data-cart-item-remove]',
      '[data-remove-item]',
      '[data-line-remove]',
      '.cart__remove',
      '.cart-remove',
      '.cart-item__remove',
      '.ajaxcart__remove',
      '.ajax-cart__remove',
      '[aria-label*="remove" i]',
      '[title*="remove" i]',
      '[class*="remove" i]',
      '[class*="trash" i]',
      '[class*="delete" i]'
    ].join(',');
    var excludeSelector = '[aria-label*="close" i], [title*="close" i], [class*="close" i], [class*="qty" i], [class*="quantity" i], [class*="plus" i], [class*="minus" i], [name="updates[]"], [href*="checkout"], .checkout, .btn, input, select, textarea';

    function closest(element, selector) {
      return element && element.closest ? element.closest(selector) : null;
    }

    function isVisible(element) {
      if (!element || !document.documentElement.contains(element)) return false;
      if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
      var styles = window.getComputedStyle(element);
      if (styles.display === 'none' || styles.visibility === 'hidden') return false;
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function visibleCartRootFor(element) {
      var root = closest(element, cartRootSelector);
      if (root && isVisible(root)) return root;

      var carts = Array.prototype.slice.call(document.querySelectorAll(cartRootSelector));
      for (var i = 0; i < carts.length; i++) {
        if (isVisible(carts[i]) && carts[i].contains(element)) return carts[i];
      }

      return null;
    }

    function centerElement(element) {
      if (!element || !element.getBoundingClientRect) return null;
      var rect = element.getBoundingClientRect();
      var x = Math.max(rect.left + 1, Math.min(rect.left + rect.width / 2, rect.right - 1));
      var y = Math.max(rect.top + 1, Math.min(rect.top + rect.height / 2, rect.bottom - 1));
      return document.elementFromPoint(x, y);
    }

    function isSmallIconControl(element) {
      if (!element || !element.getBoundingClientRect) return false;
      var rect = element.getBoundingClientRect();
      var hasIcon = (element.matches && element.matches('svg, path, use, [tabindex], [role="button"]')) || !!(element.querySelector && element.querySelector('svg, path, use, img'));
      return hasIcon && rect.width > 0 && rect.height > 0 && rect.width <= 96 && rect.height <= 96;
    }

    function removeControlFor(element) {
      var root = visibleCartRootFor(element);
      if (!root) return null;

      var control = closest(element, removeSelector);
      if (control && root.contains(control) && isVisible(control) && !closest(control, excludeSelector)) return control;

      control = closest(element, 'button, a, [role="button"], [tabindex], svg');
      if (control && root.contains(control) && isVisible(control) && !closest(control, excludeSelector) && closest(control, cartItemSelector) && isSmallIconControl(control)) return control;

      return null;
    }

    function triggerActivation(target) {
      if (!target || !isVisible(target)) return;

      ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
        var EventConstructor = type.indexOf('pointer') === 0 && window.PointerEvent ? PointerEvent : MouseEvent;
        target.dispatchEvent(new EventConstructor(type, {
          bubbles: true,
          cancelable: true,
          view: window,
          button: 0,
          buttons: type === 'pointerdown' || type === 'mousedown' ? 1 : 0
        }));
      });

      if (typeof target.click === 'function') target.click();
      if (window.jQuery) window.jQuery(target).trigger('click');
    }

    function activationTargets(focusedElement, control) {
      var targets = [];
      var center = centerElement(focusedElement) || centerElement(control);
      var icon = control && control.querySelector ? control.querySelector('svg, path, use, img') : null;
      [center, focusedElement, icon, control].forEach(function (target) {
        if (target && targets.indexOf(target) === -1) targets.push(target);
      });
      return targets;
    }

    function labelRemoveControls(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var controls = Array.prototype.slice.call(scope.querySelectorAll(removeSelector + ', svg[tabindex], [tabindex][role="button"], [tabindex="0"]'));

      controls.forEach(function (control) {
        if (!removeControlFor(control)) return;
        var tag = (control.tagName || '').toLowerCase();
        var isNative = tag === 'button' || tag === 'a';
        if (!isNative && !control.hasAttribute('role')) control.setAttribute('role', 'button');
        if (!isNative && !control.hasAttribute('tabindex')) control.setAttribute('tabindex', '0');
        if (!control.hasAttribute('aria-label') && !control.hasAttribute('title')) control.setAttribute('aria-label', 'Remove item from cart');
      });
    }

    document.addEventListener('keydown', function (event) {
      var isActivationKey = event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';
      if (!isActivationKey || event.repeat || event.defaultPrevented) return;

      var focusedElement = event.target && event.target.nodeType === 1 ? event.target : document.activeElement;
      var control = removeControlFor(focusedElement);
      if (!control) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      window.setTimeout(function () {
        activationTargets(focusedElement, control).forEach(triggerActivation);
      }, 0);
    }, true);

    document.addEventListener('keyup', function (event) {
      var isActivationKey = event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';
      if (!isActivationKey) return;
      var focusedElement = event.target && event.target.nodeType === 1 ? event.target : document.activeElement;
      if (!removeControlFor(focusedElement)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { labelRemoveControls(document); }, { once: true });
    } else {
      labelRemoveControls(document);
    }

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (node && node.nodeType === 1) labelRemoveControls(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  loadOriginalTheme(function () {
    installStyledSelectAriaFix();
    installExtendFocusGate();
    installCartRemoveKeyboardFix();
  });
})();
